import request from "_private/utils/request";

// 获取温湿度标准下拉 tree
export function FetchHumitureName() {
  return request({
    url: "/base/tempAndHumiditySet/getNames",
    method: "get"
  });
}

/**
 * 获取列表数据
 * @param {*} data
 */
export function FetchFindByPage(data) {
  return request({
    url: "/base/tempAndHumiditySet/findByPage",
    method: "post",
    headers: { type: "json" },
    data
  });
}

/**
 * 获取温湿度标准设置信息接口
 * @param {*} data
 */
export function findTempAndHumiditySetInfoById(data) {
  return request({
    url: "/base/tempAndHumiditySet/findTempAndHumiditySetInfoById",
    method: "post",
    data
  });
}

/**
 * 新增 or 修改温湿度标准设置接口
 * @param {*} data
 */
export function saveTempAndHumiditySet(data) {
  return request({
    url: "/base/tempAndHumiditySet/saveTempAndHumiditySet",
    method: "post",
    headers: { type: "json" },
    data
  });
}

/**
 * 删除字典数据
 * @param {*} data
 */

export function deleteTempAndHumiditySetByIdList(data) {
  return request({
    url: "/base/tempAndHumiditySet/deleteTempAndHumiditySetByIdList",
    method: "post",
    headers: { type: "json" },
    data
  });
}
